import { BasicProps, Content } from "antd/es/layout/layout";
import { FC, RefAttributes } from "react";

export type IncContentProps = BasicProps & RefAttributes<HTMLElement>;

export const IncConent: FC<IncContentProps> = (props) => <Content {...props} />;
